import { useContext } from 'react';
import { AppContext } from '../context/app-data.context';
import { UserPermissionName } from '../models/user-permission-name';

export const useAuthorize = (requiredPermissions: UserPermissionName[]): boolean => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('Hook must be used within a AppContextProvider');
  }
  const allPermissions = context.appData.user.userPermissions;

  return requiredPermissions.every((permission) => allPermissions.some((p) => permission === p));
};
